import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { Trans, useTranslation } from 'react-i18next';


const LearningTutorialPanel = (props) => {
    const { t } = useTranslation(["common", "glossary", "Index/TutorialPanel"]);

    const [step, setStep] = useState(0);

    useEffect(() => { $("#tutorial-menu").scrollTop(0); }, [step]);

    return <>
        {
            step == 0 ? <>
                <div className = "fs-1">{ t("glossary:welcome") } !</div>
                <p>
                    <Trans 
                        t = { t }
                        i18nKey = { "Index/TutorialPanel:learning.firstParagraph" }
                        components = {[<br key = { 0 } />]}
                    />
                </p>
                <button
                    type = "button"
                    className = 'btn btn-lg btn-outline-light fs-3'
                    onClick = { () => { setStep(step + 1); }}
                >
                    { t("Index/TutorialPanel:learning.viewInstructionsButton") }
                </button>
            </> :
            null
        }
        {
            step == 1 ? <>
                <p>
                    <Trans
                        t = { t }
                        i18nKey = { "Index/TutorialPanel:learning.secondParagraph" }
                        count = { props.nbLearningPatterns }
                        values = {{ count: props.nbLearningPatterns }}
                        components = {[<br key = { 0 } />]}
                    />
                </p>
                <button
                    type = "button"
                    className = 'btn btn-lg btn-outline-light border-0 fs-3'
                    onClick = { () => { setStep(step + 1); } }
                >
                    <i className = {`rolling-btn-icon bi bi-caret-down-fill`}></i>
                </button>
            </> :
            null
        }
        {
            step == 2 ? <>
                <button
                    type = "button"
                    className = 'btn btn-lg btn-outline-light border-0 fs-3'
                    onClick = { () => { setStep(step - 1); } }
                >
                    <i className = {`rolling-btn-icon bi bi-caret-up-fill`}></i>
                </button>
                <p>
                    <Trans
                        t = { t }
                        i18nKey = { "Index/TutorialPanel:learning.thirdParagraph" }
                        components = {[<br key = { 0 } />]}
                    />
                </p>
                <div>
                    <button
                        type = "button"
                        className = 'btn btn-lg btn-outline-light fs-3'
                        onClick = { props.startGame }
                    >
                        { t("Index/TutorialPanel:learning.startTrainingButton") }
                    </button>
                </div>
            </> :
            null
        }
    </>;
};

LearningTutorialPanel.propTypes = {
    nbLearningPatterns: PropTypes.number,
    startGame: PropTypes.func,
};


const TransferTutorialPanel = (props) => {
    const { t } = useTranslation(["common", "glossary", "Index/TutorialPanel"]);

    return <>
        <div className = "fs-1">{ t("Index/TutorialPanel:transfer.title") }</div>
        <p>
            <Trans
                t = { t }
                i18nKey = { "Index/TutorialPanel:transfer.text" }
                count = { props.nbTransferPatterns }
                values = {{ count: props.nbTransferPatterns }}
                components = {[<br key = { 0 } />]}
            />
        </p>
        <div>
            <button
                type = "button"
                className = 'btn btn-lg btn-outline-light fs-3'
                onClick = { props.resumeGame }
            >
                { t("glossary:continue") }
            </button>
        </div>
    </>;
};

TransferTutorialPanel.propTypes = {
    nbTransferPatterns: PropTypes.number,
    resumeGame: PropTypes.func,
};


export {
    LearningTutorialPanel,
    TransferTutorialPanel
};